interface IProps {
  size?: number;
  color?: string;
}

const ProofingActivePillIcon = ({
  size = 14,
  color = "#7C3AED",
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="7" cy="7" r="6" stroke={color} strokeWidth="1.25" />
      <path
        d="M8.6 4.1L9.9 5.4L6.2 9.1L4.6 9.4L4.9 7.8L8.6 4.1Z"
        stroke={color}
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { ProofingActivePillIcon };
